module.exports = __webpack_public_path__ + "assets/img/camera-retake.04d28ece.svg";